import { Injectable } from '@angular/core';
import { AppSettings } from '../_helpers/app.settings';
import { ApiConfig } from '../_helpers/api-config';
import { Request } from '../_helpers/request';
import { HttpService } from '../shared/http.service';
@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(
    private http: HttpService
  ) { }

  register(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.POST,
      url: `${ApiConfig.register}`,
      reqBody: param.data,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
}
